<!-- 代理商等级 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="gomodal">新增等级</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection" >
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="gomodal(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{ delData.length }}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="500" :mask-closable="false">
            <div>
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="等级名称：">
                        <Input type="text" v-model="formData.level_name" placeholder="请输入等级名称"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    agent_level_list,
    agent_level_save,
    agent_level_delete,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "等级名称", key: "level_name", align: "center" },
                { title: "代理（经销）商数量", key: "agent_count", align: "center", },
                { title: "操作", slot: "operate", align: "center", width: "200px", },
            ],
            dataTable: [],
            formData: {
                id: "",
                level_name: "",
            },
            modals: false,
            modalTitle: "",
            // selection
            del_id: "",
            delData: [],
            del_value: false,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            agent_level_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 搜索
        goSearch() {
            this.getList();
        },
        // 确定
        submitModal() {
            if (!this.formData.level_name) {
                this.$Message.error("请输入等级名称");
                return;
            }
            agent_level_save(this.formData).then((res) => {
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        // 取消
        cancelModal() {
            this.modals = false;
        },
        // 新增/编辑
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑代理商等级";
                this.formData.id = row.id;
                this.formData.level_name = row.level_name;
            } else {
                this.modalTitle = "新增代理商等级";
                this.formData.id = "";
                this.formData.level_name = "";
            }
            this.modals = true;
        },
        // 删除
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            let that = this;
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(",");
                        agent_level_delete({ id: this.del_id }).then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    } else if (index == 1) {
                        agent_level_delete({ id: row.id }).then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }
                },
                onCancel: () => {
                },
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框 */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-form-item {
    margin-bottom: 0 !important;
}
</style>